import * as actions from "./actions";

const usuariosStore = {
  namespaced: true,
  actions,
};

export default usuariosStore;
